import * as React from "react";
import TopBar from "./Ops.UserMessaging.UserMessageDetailTopBar";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import { match } from "react-router-dom";
import Page from "../../UserMessaging/UserMessagePageContainer";
import Info from "../../UserMessaging/UserMessageSummaryInfoContainer";
import EditPageModal from "../../UserMessaging/UserMessageEditPageModal";
import DeletePageModal from "../../UserMessaging/UserMessageDeletePageModal";
import Button from "@material-ui/core/Button";
import handleMutationError from "app/utils/handleMutationError";

import {
  UserMessage,
  UserMessagePage,
} from "../../UserMessaging/userMessageTypes";

type Props = {
  match: match<{ id: string }>;
  data: any;
  editUserMessage: any;
};

type State = {
  message: UserMessage | null;
  saving: boolean;
  pageEditing: UserMessagePage | null;
  pageDeleting: UserMessagePage | null;
};

const pageMargin = 20;

const pageComparator = function (
  page1: UserMessagePage,
  page2: UserMessagePage
) {
  return page1.id - page2.id;
};

const getPageWidthPercentage = function (pageCount: number): number {
  const percentage = 100 / pageCount;
  if (percentage > 33) {
    return 33;
  }
  return percentage;
};

const getMessageFromProps = function (props: Props): UserMessage | null {
  return props.data &&
    props.data.user_messages &&
    props.data.user_messages.length === 1
    ? props.data.user_messages[0]
    : null;
};

const newPage: UserMessagePage = { id: null, body: "", image: "" };

class Edit extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      saving: false,
      message: getMessageFromProps(props),
      pageEditing: null,
      pageDeleting: null,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    const incomingMessage = getMessageFromProps(nextProps);
    if (getMessageFromProps(this.props) !== incomingMessage) {
      this.setState({ message: incomingMessage });
    }
  }

  onChangeMessage = (userMessage: UserMessage): void => {
    this.setState({ message: userMessage });
  };

  onSave = (): void => {
    this.setState({ saving: true });
    this.props
      .editUserMessage({
        variables: {
          id: this.state.message.id,
          title: this.state.message.title,
          description: this.state.message.description,
          expires_at: this.state.message.expires_at,
          deeplink_action:
            this.state.message.deeplink_action_path +
            this.state.message.deeplink_action_uid,
          external_action: this.state.message.external_action,
          icon: this.state.message.icon_identifier,
        },
      })
      .then(() => {
        this.props.data.refetch();
        alert("Message Saved successfully");
      })
      .catch((error) => {
        handleMutationError(error);
      })
      .finally(() => this.setState({ saving: false }));
  };

  onCloseModal = (options = { refetchData: false }) => {
    this.setState({ pageEditing: null, pageDeleting: null });
    if (options.refetchData) {
      this.props.data.refetch();
    }
  };

  render() {
    const message: UserMessage | null = this.state.message;

    const pages: Array<UserMessagePage> = message
      ? (message.user_message_pages || []).concat()
      : [];

    const pageWidth = getPageWidthPercentage(pages.length);
    return (
      <div>
        <TopBar
          userMessageId={this.props.match.params.id}
          showEdit={message ? message.user_targeting_type === "draft" : true}
        />
        <section className="padded scrollable">
          {message ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  borderBottom: "1px solid #aaa",
                  alignItems: "flex-end",
                }}
              >
                <h1 style={{ margin: 0 }}>Edit Message Info</h1>
                <div>
                  <Button
                    color="default"
                    href={message.snapmin_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Snapmin
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onSave}
                    disabled={this.state.saving}
                  >
                    {this.state.saving ? "Saving..." : "Save"}
                  </Button>
                </div>
              </div>
              <Info
                editMode={true}
                onChangeMessage={this.onChangeMessage}
                message={message}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "row",
                  borderBottom: "1px solid #aaa",
                  alignItems: "flex-end",
                }}
              >
                <h1 style={{ borderBottom: "1px solid #aaa", margin: 0 }}>
                  Pages
                </h1>
                <Button
                  color="primary"
                  onClick={() => this.setState({ pageEditing: newPage })}
                >
                  Add New
                </Button>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  marginTop: "15px",
                  flex: "0 0 auto",
                }}
              >
                {pages.sort(pageComparator).map((page, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        flex: `0 0 calc(${pageWidth}% - ${pageMargin * 2}px`,
                        marginLeft: `${pageMargin}px`,
                        marginRight: `${pageMargin}px`,
                        justifyContent: "flex-start",
                      }}
                    >
                      <Page page={page} pageNumber={index} safeMode={false} />
                      <Button
                        color="primary"
                        onClick={() => this.setState({ pageEditing: page })}
                      >
                        Edit
                      </Button>
                      <Button
                        color="secondary"
                        onClick={() => this.setState({ pageDeleting: page })}
                      >
                        Delete
                      </Button>
                    </div>
                  );
                })}
              </div>
              {this.state.pageEditing ? (
                <EditPageModal
                  page={this.state.pageEditing}
                  userMessageId={message.id}
                  close={this.onCloseModal}
                />
              ) : null}
              {this.state.pageDeleting ? (
                <DeletePageModal
                  page={this.state.pageDeleting}
                  userMessageId={message.id}
                  close={this.onCloseModal}
                />
              ) : null}
            </div>
          ) : (
            <div>Loading...</div>
          )}
        </section>
      </div>
    );
  }
}

const userMessageQuery = graphql(
  gql`
    query userMessageDetails($id: ID!) {
      user_messages(id: $id) {
        id
        title
        description
        created_at
        updated_at
        expires_at
        user_targeting_type
        version
        deeplink_action
        deeplink_action_path
        deeplink_action_uid
        external_action
        icon
        icon_identifier
        snapmin_url
        user_message_pages {
          id
          body
          deeplink_action
          deeplink_action_path
          deeplink_action_uid
          external_action
          safe_mobile_html
          image
          image_identifier
        }
      }
    }
  `,
  {
    options(props: any) {
      return {
        variables: {
          id: props.match.params.id,
        },
      };
    },
  }
);

const editUserMessage = graphql(
  gql`
    mutation editUserMessage(
      $id: ID!
      $title: String
      $description: String
      $expires_at: String
      $deeplink_action: String
      $external_action: String
      $icon: String
    ) {
      update_user_message(
        id: $id
        title: $title
        description: $description
        expires_at: $expires_at
        deeplink_action: $deeplink_action
        external_action: $external_action
        icon: $icon
      ) {
        id
      }
    }
  `,
  { name: "editUserMessage" }
);

export default compose<any>(userMessageQuery, editUserMessage)(Edit);
